import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/services/network';
import { trackEvent } from 'src/utils/segmentService';

declare type Artists = {
  id: string;
  name: string;
};

declare type Track = {
  track_id: string | number | null;
  artist?: string | undefined;
  artists: Artists[] | undefined;
  title: string | undefined;
  version: string | undefined;
  start_date: string;
  upload_s3_bucket: string;
  upload_s3_key: string;
  src_filename: string;
  release_id: string | null;
};

declare type S3RequestData = {
  release_id?: string;
  identifier: string;
  tracks: Track[];
};

declare type enterpriseS3RequestData = {
  release_id?: string;
  identifier: string;
  items: Track[];
};

// Build release id list
const buildReleaseIdList = (tracks: Track[]): string => {
  return Array.from(
    new Set(tracks.map((track) => track.release_id).filter((id) => id !== null))
  ).join(',');
};

export const uploadFilesToPlaylist = createAsyncThunk(
  'UPLOAD_FILE_TO_PLAYLIST',
  async (s3RequestData: S3RequestData) => {
    return axios.post('/assets/mtr/songs', s3RequestData).then((response) => {
      const releaseIdList = buildReleaseIdList(s3RequestData.tracks);
      trackEvent('Assets Uploaded', {
        asset_count: s3RequestData.tracks?.length.toString() || '',
        release_id: releaseIdList || '',
      });
      return response.data;
    });
  }
);

export const enterpriseUploadFilesToPlaylist = createAsyncThunk(
  'ENTERPRISE_UPLOAD_FILE_TO_PLAYLIST',
  async (s3RequestData: enterpriseS3RequestData) => {
    const releaseIdList = buildReleaseIdList(s3RequestData.items);
    return axios
      .post('/subscriptions/mtr/enterprise/songs', s3RequestData)
      .then((response) => {
        trackEvent('Assets Uploaded', {
          asset_count: s3RequestData.items?.length.toString() || '',
          release_id: releaseIdList || '',
        });
        return response.data;
      });
  }
);

export const deleteTrack = createAsyncThunk(
  'DELETE_TRACK',
  async (ids: string[]) => {
    return axios
      .delete('/assets/mtr/songs', {
        data: { song_ids: ids },
      })
      .then((response) => {
        return response.data;
      });
  }
);

export const getReleaseTracksByReleaseList = createAsyncThunk(
  'GET_RELEASE_TRACKS_LIST',
  async (releaseIds: string[], { rejectWithValue }) => {
    return axios
      .post(`/subscriptions/mtr/releases/get-tracks`, {
        release_ids: releaseIds,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return rejectWithValue(error.response.status);
      });
  }
);

export const getArtists = createAsyncThunk('GET_ARTISTS', async () => {
  return axios.get('/subscriptions/mtr/artists/promoted').then((response) => {
    return response.data;
  });
});

export default uploadFilesToPlaylist;
